<script setup>
import { computed } from 'vue';
import TextArea from 'dashboard/components-next/textarea/TextArea.vue';

const props = defineProps({
  modelValue: {
    type: String,
    default: '',
  },
  placeholder: {
    type: String,
    default: '',
  },
  minHeight: {
    type: String,
    default: '3.25rem',
  },
  maxHeight: {
    type: String,
    default: '6rem',
  },
  variant: {
    type: String,
    default: 'bubble',
  },
});

const emit = defineEmits(['update:modelValue']);

const wrapperClassMap = {
  bubble: '!min-h-[3.25rem] !border-0 !bg-transparent !p-0',
  bubbleCompact: '!border-0 !bg-transparent !p-0',
  fixedBubble: '!h-[3.5rem] !border-0 !bg-transparent !p-0',
};

const textAreaClassMap = {
  bubble:
    '!min-h-[3.25rem] !resize-none !bg-transparent !p-0 !text-[12px] !leading-5 !text-n-slate-12',
  bubbleCompact:
    '!resize-none !bg-transparent !p-0 !text-[12px] !leading-5 !text-n-slate-12',
  fixedBubble:
    '!h-[3.5rem] !resize-none !overflow-y-auto !bg-transparent !p-0 !text-[12px] !leading-5 !text-n-slate-12',
};

const resolvedWrapperClass = computed(
  () => wrapperClassMap[props.variant] || wrapperClassMap.bubble
);
const resolvedTextAreaClass = computed(
  () => textAreaClassMap[props.variant] || textAreaClassMap.bubble
);
</script>

<template>
  <TextArea
    :model-value="modelValue"
    :placeholder="placeholder"
    :show-character-count="false"
    :auto-height="false"
    :resize="false"
    :min-height="minHeight"
    :max-height="maxHeight"
    :custom-text-area-wrapper-class="resolvedWrapperClass"
    :custom-text-area-class="resolvedTextAreaClass"
    @click.stop
    @update:model-value="emit('update:modelValue', $event)"
  />
</template>
